import { render } from "./ShippingAddressInputsView.vue?vue&type=template&id=1196dd29&scoped=true"
import script from "./ShippingAddressInputsView.vue?vue&type=script&lang=js"
export * from "./ShippingAddressInputsView.vue?vue&type=script&lang=js"

import "./ShippingAddressInputsView.vue?vue&type=style&index=0&id=1196dd29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1196dd29"]])

export default __exports__